import React, { useState, useEffect } from "react";
import {
  Container,
  Heading,
  ImageItem,
  Text,
  ThemeWrapper,
} from "../../styled";
import blueBg from "../../resources/images/utils/blue.png";
import purpleBg from "../../resources/images/utils/purple.png";
import { PrepaywallBlock } from "./styled";
import {
  blackColor,
  disabledColor,
  greyTextColor,
  lightSecondColor,
  whiteColor,
} from "../../constants/colors";
import {
  prePaywallData,
  audioArray,
  mainAnswers,
  comments,
  prePaywallSlides,
  email_paywall_50_list,
  pre_paywall_list,
} from "../../constants/data";
import birdOrange from "../../resources/images/icons/bird_orange.svg";
import bird from "../../resources/images/icons/bird_white.svg";
import { useSelector } from "react-redux";
import { createEventObjectFunction, setNeededPlan } from "../../utils/helper";
import doc1img from "./../../resources/images/prePaywall/doc_1.png";
import doc2img from "./../../resources/images/prePaywall/doc_2.png";
import yaleimg from "./../../resources/images/prePaywall/yale.png";
import healthimg from "./../../resources/images/prePaywall/health.png";
import mobileBg from "../../resources/images/main/mobile_bg.png";
import arrPrev from "../../resources/images/prePaywall/arr_prev.png";
// import arrNext from "../../resources/images/prePaywall/arr_next.png.png";
import { MainBlock } from "../Main/styled";
import { Autoplay, Pagination, Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react/swiper-react";
// Import Swiper styles
import "swiper/modules/navigation/navigation.min.css";
import "swiper/swiper-bundle.css";
import { useRef } from "preact/hooks";
import Button from "../design_components/Button/Button";
import { useHistory } from "react-router";
import { personalSleepPlanGenerateEvent } from "../../firebaseAnalytics/events";
import { analytics } from "../../firebaseAnalytics";
import {
  onboardingCompleteEventAmplitude,
  personalSleepPlanGenerateEventAmplitude,
} from "../../amplitude/events";
import ReactPixel from "react-facebook-pixel";

const Prepaywall = () => {
  const [activeBullet, setActiveBullet] = useState(0);
  const [isButtonBlockVisible, setButtonBlockVisible] = useState(false);

  const remoteConfig = useSelector((state) => state.questions.remoteConfig);
  const pixelObject = useSelector((state) => state.questions.pixelObject);
  const landingId = useSelector((state) => state.questions.landingId);

  const history = useHistory();

  useEffect(() => {
    // window.scrollTo(0, document.body);
    window.addEventListener("scroll", calculateButtonView);
    return (
      () => window.removeEventListener("scroll", calculateButtonView),
      window.scrollTo(0, document.body)
    );
  }, []);

  const prevRef = useRef(null);
  const nextRef = useRef(null);

  const prefRef = useRef(null);

  const calculateButtonView = () => {
    // if (prefRef.current.getBoundingClientRect().top - window.innerHeight < 0) {
    //   setButtonBlockVisible(true);
    // } else {
    //   setButtonBlockVisible(false);
    // }
    if (window.scrollY > window.innerHeight / 2) {
      setButtonBlockVisible(true);
    } else {
      setButtonBlockVisible(false);
    }
  };

  const mainChoosePoints = useSelector(
    (state) => state.questions.answers["main"]
  );
  const audioValues = useSelector((state) => state.questions.audioValues);

  const courseItemsRender = () => {
    const items = setNeededPlan(mainChoosePoints);
    return (
      <PrepaywallBlock.Items style={{ marginBottom: 20 }}>
        <PrepaywallBlock.Line />
        {items.map((item, index) => {
          return (
            <PrepaywallBlock.Item
              key={`${item.id}-prepaywall-img`}
              style={{ marginBottom: 20 }}
            >
              <PrepaywallBlock.Item.Img
                style={{ width: 66, height: 66, marginRight: 13 }}
              >
                <img src={item.img} alt={item.title} />
              </PrepaywallBlock.Item.Img>
              <PrepaywallBlock.Item.Text>
                <Text.Eight
                  style={{
                    color: disabledColor,
                    marginBottom: 2,
                    fontWeight: 600,
                  }}
                >
                  {`DAY ${index + 1}`}
                </Text.Eight>
                <Text.Fourth
                  style={{
                    color: blackColor,
                    fontWeight: 600,
                    textAlign: "left",
                  }}
                >
                  {item.title}
                </Text.Fourth>
              </PrepaywallBlock.Item.Text>
            </PrepaywallBlock.Item>
          );
        })}
      </PrepaywallBlock.Items>
    );
  };

  const preferencesRender = () => {
    return (
      <PrepaywallBlock.Preferences
        style={{
          justifyContent:
            mainChoosePoints.length % 2 === 0
              ? "space-between"
              : "space-around",
          marginBottom: 21,
        }}
      >
        {mainChoosePoints.map((item) => {
          return (
            <PrepaywallBlock.Preferences.Item
              style={{ width: mainChoosePoints.length === 1 ? "100%" : "43%" }}
            >
              <Text.Third style={{ color: whiteColor }}>
                {mainAnswers[item].text}
              </Text.Third>
            </PrepaywallBlock.Preferences.Item>
          );
        })}
      </PrepaywallBlock.Preferences>
    );
  };

  const audioImagesRender = () => {
    return (
      <PrepaywallBlock.Audio>
        {audioValues.map((item) => {
          return (
            <PrepaywallBlock.Audio.Item
              key={`${audioArray[item].id}-prepaywall-audio`}
            >
              <PrepaywallBlock.Audio.Item.Img>
                <img
                  src={audioArray[item].shortImg}
                  alt={audioArray[item].shortName}
                />
              </PrepaywallBlock.Audio.Item.Img>
              <Text.Eight
                style={{
                  color: blackColor,
                  opacity: 0.7,
                  textTransform: "none",
                  letterSpacing: "normal",
                }}
              >
                {audioArray[item].shortName}
              </Text.Eight>
            </PrepaywallBlock.Audio.Item>
          );
        })}
      </PrepaywallBlock.Audio>
    );
  };

  const sliderRender = () => {
    return (
      <PrepaywallBlock.Slider>
        <Swiper
          modules={[Pagination, Autoplay, Navigation]}
          navigation={{
            prevEl: prevRef.current ? prevRef.current : undefined,
            nextEl: nextRef.current ? nextRef.current : undefined,
          }}
          onSlideChange={(swiper) => setActiveBullet(swiper.activeIndex)}
        >
          {prePaywallSlides.map((slide) => {
            return (
              <SwiperSlide key={`${slide.id}-pre-slide`}>
                <img
                  style={{ maxWidth: 375, width: "100%" }}
                  src={slide.img}
                  alt="slide"
                />
              </SwiperSlide>
            );
          })}
        </Swiper>
        <div className="pre-paywall-bullets">
          {comments.map((i, index) => {
            return (
              <div
                className={`pre-paywall-bullet ${
                  index === activeBullet ? "active" : null
                }`}
                key={index}
              />
            );
          })}
        </div>
      </PrepaywallBlock.Slider>
    );
  };

  const whatItemsRender = () => {
    return (
      <div
        style={{
          marginBottom: 128,
          paddingBottom: 20,
          borderBottom: "1px solid #2D2A57",
        }}
      >
        <Container.Content style={{ zIndex: 2 }}>
          <Heading.Third
            style={{
              color: lightSecondColor,
              textAlign: "left",
              marginBottom: 21,
            }}
          >
            What You Get:
          </Heading.Third>
          {pre_paywall_list.map((item, index) => {
            return (
              <ImageItem
                key={`${index}-list-pre-paywall`}
                style={{ marginBottom: 23 }}
              >
                <ImageItem.Img>
                  <img src={birdOrange} alt="bird" />
                </ImageItem.Img>
                <ImageItem.Text>
                  <Text.Fourth
                    style={{ color: greyTextColor, textAlign: "left" }}
                  >
                    {item}
                  </Text.Fourth>
                </ImageItem.Text>
              </ImageItem>
            );
          })}
        </Container.Content>
      </div>
    );
  };

  const handleButtonClick = () => {
    if (remoteConfig.paidTrialEnabled) {
      eventTrackingFunction();
      setTimeout(() => {
        history.push("/onboarding/cost");
      }, 500);
    } else {
      eventTrackingFunction();
      setTimeout(() => {
        history.push("/onboarding/paywall");
      }, 500);
    }
  };

  const eventTrackingFunction = () => {
    const eventObj = createEventObjectFunction(null, null, landingId);
    // Событие №9 personal_sleep_plan_generate
    personalSleepPlanGenerateEvent(analytics, eventObj);
    personalSleepPlanGenerateEventAmplitude(eventObj);
    ReactPixel.track("ViewContent", pixelObject);
  };

  return (
    <div style={{ width: "100%" }}>
      <ThemeWrapper style={{ paddingBottom: 37 }}>
        <img className="blue" src={blueBg} alt="bg" />
        <img className="purple" src={purpleBg} alt="bg" />
        <PrepaywallBlock>
          <Container.Content>
            <Heading.Third
              style={{ textAlign: "left", color: blackColor, marginBottom: 6 }}
            >
              Personalized Sleep Plan
            </Heading.Third>
            <Text.Fourth
              style={{ textAlign: "left", color: blackColor, marginBottom: 19 }}
            >
              We analyzed all your responses and have created a personalized
              Sleep Plan just for you!
            </Text.Fourth>
            <Container.Items style={{ marginBottom: 30 }}>
              <Heading.Fifth
                style={{
                  textAlign: "left",
                  color: blackColor,
                  marginBottom: 20,
                }}
              >
                Your Sleep Plan Includes:
              </Heading.Fifth>
              {prePaywallData.map((item) => {
                return (
                  <ImageItem
                    key={`${item.id}-prepaywall-data`}
                    style={{
                      marginBottom:
                        item.id === prePaywallData.length - 1 ? 0 : 19,
                    }}
                  >
                    <ImageItem.Img
                      style={{
                        width: 22,
                        height: 22,
                        minWidth: 22,
                        marginRight: 10,
                        boxShadow: "none",
                        background: "#5DB574",
                      }}
                    >
                      <img src={bird} alt="bird" />
                    </ImageItem.Img>
                    <ImageItem.Text style={{ minHeight: "auto" }}>
                      <Text.Fourth
                        style={{
                          color: "rgba(5, 2, 55, 0.7)",
                          textAlign: "left",
                        }}
                      >
                        {item.text}
                      </Text.Fourth>
                    </ImageItem.Text>
                  </ImageItem>
                );
              })}
            </Container.Items>
            <Heading.Third
              style={{ textAlign: "left", color: blackColor, marginBottom: 6 }}
            >
              Your Sleep Course
            </Heading.Third>
            <Text.Fourth
              style={{
                textAlign: "left",
                color: blackColor,
                marginBottom: 14,
              }}
            >
              Based on your answers, we recommend you start with a 7-Day
              personal sleep course
            </Text.Fourth>
            <Text.Fourth
              style={{
                textAlign: "left",
                color: blackColor,
                marginBottom: 10,
                paddingBottom: 6,
                borderBottom: "1px solid #C6C4DF",
              }}
            >
              <span style={{ color: blackColor, fontWeight: 600 }}>
                {" "}
                Time:{" "}
              </span>{" "}
              <span style={{ color: disabledColor }}> 15 minutes per day </span>
            </Text.Fourth>
            {courseItemsRender()}
            <Container.Items style={{ padding: "24px 7px 28px 7px" }}>
              <Text.Third
                style={{ color: blackColor, fontWeight: 800, marginBottom: 20 }}
              >
                Journey Uses Only Science-Based Techniques
              </Text.Third>
              <PrepaywallBlock.Docs>
                <PrepaywallBlock.Doc>
                  <img src={doc1img} alt="doc" />
                  <img src={yaleimg} alt="doc" />
                </PrepaywallBlock.Doc>
                <PrepaywallBlock.Doc>
                  <img src={doc2img} alt="doc" />
                  <img src={healthimg} alt="doc" />
                </PrepaywallBlock.Doc>
              </PrepaywallBlock.Docs>
            </Container.Items>
          </Container.Content>
        </PrepaywallBlock>
      </ThemeWrapper>
      <Container.Content
        style={{ paddingTop: 24, paddingBottom: 34 }}
        ref={prefRef}
      >
        <Heading.Third
          style={{ textAlign: "left", color: blackColor, marginBottom: 6 }}
        >
          Based on Your Preferences
        </Heading.Third>
        <Text.Fourth
          style={{
            textAlign: "left",
            color: blackColor,
            marginBottom: 17,
            opacity: 0.7,
          }}
        >
          We have personalized your Journey Sleep Plan to focus on the following
          topics:
        </Text.Fourth>
        {preferencesRender()}
        <Text.Fourth
          style={{
            textAlign: "left",
            color: blackColor,
            marginBottom: 19,
            opacity: 0.7,
          }}
        >
          Content will be tailored to include personalized sleep sounds based on
          your preferences:
        </Text.Fourth>
        {audioImagesRender()}
      </Container.Content>
      <PrepaywallBlock.Bottom>
        <MainBlock.Mobile>{/*<img src={mobileBg} alt="" />*/}</MainBlock.Mobile>
        <Container.Content>
          <Heading.Third
            style={{
              textAlign: "left",
              color: lightSecondColor,
              marginBottom: 6,
            }}
          >
            Personal Digital Sleep Coach
          </Heading.Third>
          <Text.Fourth
            style={{
              textAlign: "left",
              color: greyTextColor,
              marginBottom: 14,
            }}
          >
            Your Personal Digital Sleep Coach is backed up by CBT (cognitive
            behavioral therapy) methods approved by the FDA (US Food and Drug
            Administration).
          </Text.Fourth>
          <Text.Fourth
            style={{
              textAlign: "left",
              color: greyTextColor,
              marginBottom: 30,
            }}
          >
            Personal Sleep Coach will help you on your way to the perfect sleep:
          </Text.Fourth>
          {sliderRender()}
        </Container.Content>
        <div
          style={{
            borderBottom: "1px solid #2D2A57",
            marginBottom: 31,
            paddingTop: 19,
            zIndex: 3,
          }}
        />

        {whatItemsRender()}
        {isButtonBlockVisible ? (
          <PrepaywallBlock.ButtonBlock>
            <Container.Content>
              <Button
                type={"default"}
                isGradient={true}
                text={"Continue"}
                action={() => handleButtonClick()}
              />
            </Container.Content>
          </PrepaywallBlock.ButtonBlock>
        ) : null}
      </PrepaywallBlock.Bottom>
    </div>
  );
};

export default Prepaywall;
